import "./App.css";
import Routes from "../src/routes/routes";
import "../src/assets/scss/app.scss";
import "pure-react-carousel/dist/react-carousel.es.css";
import "antd/dist/antd.css";
import LogRocket from "logrocket";
import { IS_LOG_ROCKET_ON, REACT_APP_LOG_ROCKET_APP_ID } from "./helper/constants";

if (IS_LOG_ROCKET_ON && REACT_APP_LOG_ROCKET_APP_ID) {
  LogRocket.init(REACT_APP_LOG_ROCKET_APP_ID);
}

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
